import { supabase } from '@/lib/supabase/client'

export type TaskInsert = {
  title: string
  description?: string
  status?: string
  due_date?: string
}

export type Task = {
  id: string
  created_at: string
  title: string
  description: string | null
  status: string
  due_date: string | null
}

export const createTask = async (task: TaskInsert) => {
  const { data, error } = await supabase
    .from('tasks')
    .insert([task])
    .select()
    .single()

  return { data, error }
}

export const getTasks = async () => {
  const { data, error } = await supabase
    .from('tasks')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(10)

  return { data: data as Task[], error }
}
